import styled from "@emotion/styled"
import Image from "next/image"
import colors from "theme/colors"
import { Desktop, Mobile, NewText } from "ui"
import { httpsImage } from "utils/utils"

const StyledPadding = styled.div<{ $paddingTop?: number }>`
  padding: 32px 28px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 60px 146px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding: 90px 220px;
  }
`
const StyledImageContainer = styled.div`
  margin-bottom: 20px;
`
const StyledTextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`

const StyledNewText = styled(NewText)`
  p {
    margin: 0;
  }
  span{
  }
`
type Props = {
  image: { url: string; alt: string }
  texts: string[]
}

function QuoteWithImage({ image, texts }: Props) {
  return (
    <StyledPadding>
      {!!image.url && (
        <StyledImageContainer>
          <Mobile>
            <Image
              width={156}
              height={36}
              src={httpsImage(image.url)}
              alt={image.alt}
              style={{ objectFit: "contain" }}
              quality={85}
            />
          </Mobile>
          <Desktop>
            <Image
              width={277}
              height={64}
              src={httpsImage(image.url)}
              alt={image.alt}
              style={{ objectFit: "contain" }}
              quality={85}
            />
          </Desktop>
        </StyledImageContainer>
      )}
      <StyledTextsContainer>
        {texts.map((text, index) => (
          <StyledNewText
            key={index.toString()}
            mobileFontSize={24}
            desktopFontSize={40}
            component={index === 0 ? "h1" : "div"}
            desktopLineHeight="60px"
            mobileLineHeight="33.6px"
            color={colors.black}
            dangerouslySetInnerHTML={{ __html: index === 0 ? text?.replace("h3", "span") : text }}
          />
        ))}
      </StyledTextsContainer>
    </StyledPadding>
  )
}

export default QuoteWithImage
